<template>
	<div class="container">
		<div v-if="state.buttonActive" class="popup">
			<div class="tabs-container">
				<div id="bugTab" class="tab" 
				v-bind:class="{ tabBugActive: state.tabActiveBug, 'not-active': !state.tabActiveBug }" 
				@click="toggleTab($event)">
					<h2>Bug</h2>
				</div>
				<div id="otherTab" class="tab" 
				v-bind:class="{ tabOtherActive: state.tabActiveOther, 'not-active': !state.tabActiveOther }" 
				@click="toggleTab($event)">
					<h2>Other</h2>
				</div>
			</div>
			<div v-if="state.tabActiveBug" class="content">
				<form @submit.prevent="submit" autocomplete="off">
					<p>please leave a detailed description of the bug you have found</p>
					<div>
						<label class="form-label" for="summary">summary</label>
						<input class="summary" id="summary" name="summary" />
					</div>
					<div>
						<label class="form-label" for="description">description</label>
						<input class="description" id="description" name="description" />
					</div>
					<div>
						<input class="submit-button" type="submit" name="submit-button">
					</div>
				</form>
			</div>
			<div v-else>
				<p>this tab is still in its infancy</p>
			</div>
		</div>
		<div class="circle" @click="toggle">
			<h1 class="image">!</h1>
		</div>
	</div>	
</template>

<script>
import { reactive } from 'vue';
export default {
	name: 'Help',
	setup() {
		const toggle = () => state.buttonActive = !state.buttonActive;
		const toggleTab = (event) => {
			console.log(event.currentTarget.id)
			if (event.currentTarget.id == 'bugTab') {
				state.tabActiveBug = true;
				state.tabActiveOther = false;
				console.log('bug active')
			} else {
				state.tabActiveBug = false;
				state.tabActiveOther = true;
				console.log('other active')
			}
		}

		const state = reactive({
			buttonActive: false,
			tabActiveBug: true,
			tabActiveOther: false
		})

		const submit = () => console.log(`pressed: ${JSON.stringify(process.env)}`)

		return {
			state, 
			toggle,
			toggleTab,
			submit
		}
	}
}
</script>

<style scoped>

.container {
	position: absolute;
	bottom: 20pt;
	right: 20pt;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}

.container p {
	color: black;
}

.submit-button:hover {
	background: white;
	color: black;
	border: 1pt solid black;
}

.content {
	display: flex;
	justify-content: center;
}

form {
	width: 90%;
	color: black;
}

.summary, .description {
	display: block;
	box-sizing: border-box;
	width: 100%;
	height: 25pt;
	border: 1pt solid black;
	border-radius: 10pt;
	margin: 10pt 0;
	outline: none;
	padding: 0 0 0 10pt;
}

.submit-button {
	background: black;
	color: white;
	border: none;
	border-radius: 10pt;
	cursor: pointer;
	width: 100pt;
	height: 20pt;
	margin: 10pt 0;
	outline: none;
	transition: background-color 0.4s;
}

.circle {
	width: 50pt;
	height: 50pt;
	background: black;
	border-radius: 50%;
	border: 1pt solid white;
	transition: 0.5s;
	filter: drop-shadow(0 0 0.75rem white);
	position: fixed;
	bottom: 20pt;
	right: 20pt;
}

.image {
	position: relative;
	transition: 0.5s;
	top: 10pt;
	margin: 0pt;
}

.circle:hover {
	background: white;
	border: 1pt solid black;
	cursor: pointer;
	filter: drop-shadow(0 0 0.75rem black);
}

.image:hover {
	color: black;
}

.popup {
	background: white;
	height: 300pt;
	width: 250pt;
	position: relative;
	border-radius: 10pt;
	margin: 10pt;
}

.tabs-container {
	display: flex;
}

.tab {
	width: 50%;
	color: black;
}

.not-active {
	border-bottom: 1pt solid black;
}

.tab:hover {
	background: gray;
	border-radius: 10pt 10pt 0 0;
	cursor: pointer;
}

.active {
	border-bottom: none;
}

.tabBugActive {
	border-bottom: none;
	border-right: 1pt solid black;
	border-radius: 0 10pt 0 0;
}

.tabOtherActive {
	border-bottom: none;
	border-left: 1pt solid black;
	border-radius: 10pt 0 0 0;
}

.popup {
	box-shadow: 5pt -5pt 10pt black;
}
</style>